const RoleListBreadcrumb = {
	title: 'Role Management',
	path: '/secure/role',
};

const RoleDetailBreadcrumb = {
	title: 'Role Detail Information',
	path: '/secure/role/detail',
};

const RoleCreateBreadcrumb = {
	title: 'Create New Role',
	path: '/secure/role/create',
};

const RoleUpdateBreadcrumb = {
	title: 'Edit Role',
	path: '/secure/role/update',
};

export const RoleListBreadcrumbConst = [RoleListBreadcrumb];

export const RoleDetailBreadcrumbConst = [
	RoleListBreadcrumb,
	RoleDetailBreadcrumb,
];

export const RoleCreateBreadcrumbConst = [
	RoleListBreadcrumb,
	RoleCreateBreadcrumb,
];

export const RoleUpdateBreadcrumbConst = [
	RoleListBreadcrumb,
	RoleUpdateBreadcrumb,
];
